import { tw } from "@/utils";

export const ktasBgColors = {
  1: tw("bg-ktas-1"),
  2: tw("bg-ktas-2"),
  3: tw("bg-ktas-3"),
  4: tw("bg-ktas-4"),
  5: tw("bg-ktas-5"),
};

export const ktasOpacityBgColors = {
  1: tw("bg-ktas-1/10"),
  2: tw("bg-ktas-2/10"),
  3: tw("bg-ktas-3/10"),
  4: tw("bg-ktas-4/10"),
  5: tw("bg-ktas-5/10"),
};
